import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const AboutAreaTwo = () => {
  return (
    <>
      {/* =============== About Area Two End ===============*/}
      <div className='about-area pd-top-120 pd-bottom-120'>
        <div className='container'>
          <div className='row'>
            <div
              className='col-lg-6 mb-4 mb-lg-0 '
              data-aos='fade-right'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner'>
                <img
                  className='main-img rounded'
                  src='assets/img/about/quality.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>QUALITY POLICY</h6>
                <h2 className='title'>
                  Empowering businesses with High-Quality <span>Forging</span> Products
                </h2>
                <p className='content mb-4'>
                At this present time the company focuses its attention to a number of quality related issues, namely:
                </p>
                <div className='row'>
                  <div className='col-md-12'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> To instill an awareness of quality related issues among all staff members by means of improved training and understanding of the critical role which quality plays in the company's business.
                      </li>
                      <li>
                        <FaCheckCircle /> The policies, organization and procedures detailed in the company Quality Manual are designed to achieve our quality goals in the most efficient manner.
                      </li>
                      <li>
                        <FaCheckCircle /> The Top Management considers the quality aspects of the company's business to be of paramount importance, as only service which provides on-going customer satisfaction will guarantee the continuing success of the company
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* =============== About Area Two End ===============*/}
    </>
  );
};

export default AboutAreaTwo;
